(function () {
  const searchModal = () => {
    $(".search-modal-trigger,.search-modal__overlay,.search__close").click(
      function (e) {
        e.preventDefault();
        searchToggle($(this));
      }
    );
  };
  $(document).on("keyup", function (e) {
    if ($(".search-modal").hasClass("active") && e.key == "Escape") {
      searchToggle();
    }
  });
  function searchToggle(trigger) {
    const $modal = $("#search-modal");
    const $body = $("body");
    const willOpen = !$modal.hasClass("active");
    $modal.toggleClass("active");
    $body.toggleClass("overflow-hidden");
    if (willOpen) {
      // Set ARIA state and focus trap entry
      $modal.attr("aria-hidden", "false");
      $('[aria-controls="search-modal"]').attr("aria-expanded", "true");
      $modal.attr("tabindex", "-1")[0].focus();
      // Focus the input after modal focus lands
      setTimeout(() => {
        $modal.find(".search__input").trigger("focus");
      }, 0);
      // Save the trigger to restore focus
      if (trigger && trigger.length) {
        $modal.data("return-focus", trigger);
      }
    } else {
      $modal.attr("aria-hidden", "true");
      $('[aria-controls="search-modal"]').attr("aria-expanded", "false");
      // Restore focus to invoking control
      const $returnTo =
        $modal.data("return-focus") || $(".search-modal-trigger").first();
      $returnTo.trigger("focus");
    }
    // Basic focus trap
    setTimeout(() => {
      if ($modal.hasClass("active")) {
        const focusable = $modal
          .find(
            'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
          )
          .filter(":visible");
        const first = focusable.first();
        const last = focusable.last();
        $modal.off("keydown.focus-trap").on("keydown.focus-trap", function (e) {
          if (e.key === "Tab") {
            if (e.shiftKey && document.activeElement === first[0]) {
              e.preventDefault();
              last[0].focus();
            } else if (!e.shiftKey && document.activeElement === last[0]) {
              e.preventDefault();
              first[0].focus();
            }
          }
        });
      } else {
        $modal.off("keydown.focus-trap");
      }
    }, 0);
  }
  document.addEventListener("shopify:section:load", searchModal);
  searchModal();
})();
